import React from 'react';
import {Modal, Fade} from '@mui/material';
import ApplyDiscountComponent from './component';

interface ApplyDiscountContainerProps {
  applyDiscountModalOpen: boolean;
  setApplyDiscountModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  currentAmount: string;
  paymentId?: string;
}

const ApplyDiscountContainer: React.FC<ApplyDiscountContainerProps> = ({
  applyDiscountModalOpen,
  setApplyDiscountModalOpen,
  currentAmount,
  paymentId = '',
}) => {
  return (
    <Modal
      open={applyDiscountModalOpen}
      onClose={() => setApplyDiscountModalOpen(false)}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      className="discount-modal-backdrop"
    >
      <Fade in={applyDiscountModalOpen}>
        <div className="discount-modal-wrapper">
          <ApplyDiscountComponent
            applyDiscountModalOpen={applyDiscountModalOpen}
            setApplyDiscountModalOpen={setApplyDiscountModalOpen}
            currentAmount={currentAmount}
            paymentId={paymentId}
          />
        </div>
      </Fade>
    </Modal>
  );
};

export default ApplyDiscountContainer;
